import {Box, Typography} from '@mui/material';
import React from 'react';

interface ICustomFieldSectionProps {
  title?: string;
  rightContent?: React.ReactNode;
}

const CustomFieldSection: React.FC<
  React.PropsWithChildren<ICustomFieldSectionProps>
> = ({title, rightContent, children}) => {
  return (
    <Box className="section-container">
      <Box className={'section-header'}>
        <Typography className={'typo-text subhead5_size text-label'} tabIndex={0}>
          {title?.toUpperCase()}
        </Typography>
        {rightContent}
      </Box>
      {children && <Box className={'section-body'}>{children}</Box>}
    </Box>
  );
};

export {CustomFieldSection};
